import { ApprovalRequestState } from '../../../types/ApprovalRequestState';

import { OrderTab, orderTabOfferStateFilter, orderTabStateFilter } from './orderTabsHelper';
import { mapFilterToApprovalState, mapFilterToOfferState } from './quickfilter/quickFilterMappingHelper';
import { QuickFilterValue, QuickFilterValueEnum } from './quickfilter/QuickFilterValueTypes';

interface OrderFilterStates {
    offerStates: string[];
    states: string[];
    approvalRequestStates?: ApprovalRequestState[];
}

export const resolveOrderFilterStates = (tab: OrderTab, quickFilter: QuickFilterValue): OrderFilterStates => {
    const baseOfferStates = orderTabOfferStateFilter[tab];
    const baseStates = orderTabStateFilter[tab];

    // If quickFilter is ALL, use base states only
    if (quickFilter === QuickFilterValueEnum.ALL) {
        return {
            offerStates: baseOfferStates || [],
            states: baseStates || [],
        };
    }

    const quickFilterOfferStates = mapFilterToOfferState(quickFilter);
    const quickFilterApprovalStates = mapFilterToApprovalState(quickFilter);

    return {
        offerStates: quickFilterOfferStates || baseOfferStates || [],
        states: baseStates || [],
        approvalRequestStates: quickFilterApprovalStates || undefined,
    };
};
